/** Crusade history by year, migrated from the source site's crusade archive. */
export const CRUSADE_HISTORY: { year: string; cities: string[] }[] = [
  { year: "2005", cities: ["Tela, Honduras"] },
  { year: "2006", cities: ["Santa Cruz, Honduras", "Siguatepeque, Honduras"] },
  {
    year: "2007",
    cities: ["Tocoa, Honduras", "Puerto Plata, Dominican Republic", "La Esperanza, Honduras"],
  },
  {
    year: "2008",
    cities: [
      "Puerto Barrios, Guatelama",
      "La Romana, Dominican Republic",
      "La Entrada, Honduras",
      "Yoro, Honduras",
    ],
  },
  {
    year: "2009",
    cities: ["Villanueva, Honduras", "Puntarenas, Costa Rica", "Rivera Hernandez, Honduras"],
  },
  {
    year: "2010",
    cities: [
      "Puntarenas, Costa Rica II",
      "Santa Ana, El Salvador",
      "La Lima, Honduras",
      "Puerto Cortes, Honduras",
    ],
  },
  {
    year: "2011",
    cities: ["Chamelecon, Honduras", "Cofradia, Honduras", "Choloma, Honduras"],
  },
  { year: "2012", cities: ["San Pedro Sula, Honduras"] },
  { year: "2013", cities: ["Managua, Nicaragua"] },
  { year: "2014", cities: ["Colon, Panama", "Panama City, Panama", "Mexico City, Mexico"] },
  { year: "2015", cities: ["Danli, Honduras", "Masaya, Nicaragua"] },
  {
    year: "2016",
    cities: ["Guapiles, Costa Rica", "Bay Islands, Honduras", "Ocotepeque, Honduras"],
  },
  {
    year: "2017",
    cities: [
      "San Lorenzo, Honduras",
      "Choluteca, Honduras",
      "Puerto Lempira, Honduras",
      "Santa Tecla, El Salvador",
    ],
  },
  { year: "2018", cities: ["Tegucigalpa, Honduras", "Quezaltepeque, El Salvador"] },
  {
    year: "2019",
    cities: ["Encarnacion, Paraguay", "Soyapango, El Salvador", "San Marcos, El Salvador"],
  },
  { year: "2020", cities: ["Marcala, Honduras"] },
  {
    year: "2021",
    cities: ["Gracias, Honduras", "Olancho, Honduras", "Santa Barbara, Honduras"],
  },
  {
    year: "2022",
    cities: [
      "Comayagua, Honduras",
      "Orange Walk, Belize",
      "Copan Ruinas, Honduras",
      "Chimoio, Mozambique",
    ],
  },
  {
    year: "2023",
    cities: [
      "Iquitos, Peru",
      "Quelimane, Mozambique",
      "Illovo, South Africa",
      "Santa Rosa, Honduras",
      "Ushuaia, Argentina",
    ],
  },
  {
    year: "2024",
    cities: [
      "Mahalapye, Botswana",
      "El Progreso, Honduras",
      "Tete, Mozambique",
      "Punta Arenas, Chile",
    ],
  },
  {
    year: "2025",
    cities: [
      "Mokhotlong, Lesotho",
      "Tela, Honduras",
      "Mponela, Malawi",
      "São Paulo, Brazil",
      "Fort Worth, USA",
    ],
  },
  {
    year: "2026",
    cities: [
      "Qacha's Nek, Lesotho",
      "Georgetown, Guyana",
      "Saint-Laurent, French Guiana",
      "Paramaribo, Suriname",
      "La Entrada, Honduras",
      "Willemstad, Curaçao",
      "Nicoadala, Mozambique",
    ],
  },
];

/** Upcoming crusades, shown on the homepage slider, Crusades page and Join Us. */
export type UpcomingCrusade = {
  city: string;
  country: string;
  dates: string;
  image: string;
  /** Detail page slug, when one exists. */
  slug?: string;
};

export const UPCOMING_CRUSADES: UpcomingCrusade[] = [
  {
    city: "Tarija",
    country: "Bolivia",
    dates: "October 18 – 27, 2026",
    image: "/media/crusades-loop-background-updated.jpg",
    slug: "tarija-bolivia",
  },
  {
    city: "La Ceiba",
    country: "Honduras",
    dates: "May 31 – June 6, 2027",
    image: "/media/LOLI_Events_1-1-scaled.jpeg",
  },
];


export const CRUSADE_COUNT = CRUSADE_HISTORY.reduce((sum, y) => sum + y.cities.length, 0);

/** Highlight videos, in the order they appear on the source site. */
export const HIGHLIGHT_VIDEOS: { title: string; id: string; thumb: string }[] = [
  { title: "Honduras Prays", id: "b0Ir9HiTI9o", thumb: "/media/vm01.webp" },
  { title: "Quezaltepeque, El Salvador", id: "QXhnA8m9tQQ", thumb: "/media/vm02.webp" },
  { title: "Paraguay Outpouring", id: "0dZ4zi8Woio", thumb: "/media/vm03.webp" },
  { title: "Soyapango, El Salvador", id: "4s6swDqzfCA", thumb: "/media/vm04.webp" },
  { title: "San Marcos, El Salvador", id: "eGLQkBv-8pY", thumb: "/media/vm05.webp" },
  { title: "Olancho, Honduras", id: "TsnlYuxLBqs", thumb: "/media/vm06.webp" },
  { title: "Santa Barbara, Honduras", id: "GIjSU9vPIP4", thumb: "/media/vm07.webp" },
  { title: "Comayagua, Honduras", id: "orwm3cJskYo", thumb: "/media/vm08.webp" },
  { title: "Belize", id: "Se8TVOsPgx8", thumb: "/media/vm01.webp" },
  { title: "Chimoio, Mozambique", id: "C-OAz9WpQ0E", thumb: "/media/vm02.webp" },
  { title: "Iquitos, Peru", id: "e8K7GZp66nI", thumb: "/media/vm03.webp" },
];

/** Crusade detail pages, matching the source site's `crusade` post type slugs. */
export type CrusadePage = {
  slug: string;
  city: string;
  country: string;
  dates: string;
  image: string;
  contentKey: string;
};

export const crusadePages: CrusadePage[] = [
  {
    slug: "tarija-bolivia",
    city: "Tarija",
    country: "Bolivia",
    dates: "October 18 – 27, 2026",
    image: "/media/crusades-loop-background-updated.jpg",
    contentKey: "crusade__tarija-bolivia",
  },
];
